import { render, staticRenderFns } from "./textos.vue?vue&type=template&id=7288ef20"
import script from "./textos.vue?vue&type=script&lang=js"
export * from "./textos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports